var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"parent-contact-teacher"},[_c('div',{staticClass:"page-header"},[_c('h1',[_vm._v("联系老师")]),_c('p',[_vm._v("孩子ID: "+_vm._s(_vm.$route.params.childId))]),_c('p',[_vm._v("家长联系老师页面，开发中...")])])])}
var staticRenderFns = []

export { render, staticRenderFns }